import { TIndent } from 'app/services/api5-service/api.interface';

/**
 * Get group indent size
 *
 * @param indentType
 */
export function getGroupRowGap(indentType?: TIndent): string | undefined {
  switch (indentType) {
    case 'small':
      return '15px';
    case 'medium':
      return '20px';
    case 'large':
      return '25px';
    case 'extra_large':
      return '30px';
    default:
      return undefined;
  }
}
